import { render } from "./user-breadcrumb.vue?vue&type=template&id=5f39cad5"
import script from "./user-breadcrumb.vue?vue&type=script&lang=js"
export * from "./user-breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__